<template>
  <!-- :rules="rules" -->
  <div class="view-container">
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      label-width="120px"
      @handleConfirm="handleConfirm"
    >
      <BjDivider>{{ $t('ChannelManagement.new.title') }}</BjDivider>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.Account')" prop="account">
            <BjInput
              v-model="form.account"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.API')" prop="apiServiceUrl">
            <BjInput
              v-model="form.apiServiceUrl"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.app_Key')" prop="appKey">
            <BjInput
              v-model="form.appKey"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
              type="textarea"
              autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.appSecret')" prop="appSecret">
            <BjInput
              v-model="form.appSecret"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
              type="textarea"
              autosize
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.name')" prop="appName">
            <BjInput
              v-model="form.appName"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.type')" prop="appType">
            <el-select v-model="form.appType" class="full-width" :placeholder="$t('chooseText')" clearable>
              <el-option
                v-for="item in appTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.Authorizable')" prop="authAccount">
            <BjInput
              v-model="form.authAccount"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.address')" prop="authUrl">
            <BjInput
              v-model="form.authUrl"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.Callback')" prop="callBackUrl">
            <BjInput
              v-model="form.callBackUrl"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.Other')" prop="otherUrl">
            <BjInput
              v-model="form.otherUrl"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.Development')" prop="platformAddress">
            <BjInput
              v-model="form.platformAddress"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ChannelThirdPartyPlatform.Remarks')" prop="remark">
            <BjInput
              v-model="form.remark"
              :maxlength="MAX_LENGTH.NORMAL"
              :placeholder="$t('inputText')"
              clearable
              type="textarea"
              autosize
            />
          </el-form-item>
        </el-col>
      </el-row>
    </BjDrawerForm>
  </div>
</template>
<script>
import axios from 'axios';
const getDefaultForm = () => {
  return {
    account: null,
    apiServiceUrl: null,
    appKey: null,
    appName: null,
    appType: null,
    authAccount: null,
    authUrl: null,
    callBackUrl: null,
    appSecret: null,
    otherUrl: null,
    platformAddress: null,
    remark: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {
        account: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        apiServiceUrl: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        appKey: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        appSecret: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        appName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        appType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        authUrl: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      appTypeOptions: [
        { label: 'ChannelAdvisor', value: 'CA' },
        { label: 'Amazon', value: 'AMZ' },
        { label: 'Shopify', value: 'SPF' },
        { label: 'ManualImport', value: 'MAN' },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.$t('ChannelThirdPartyPlatform.third'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      console.log('queding ');
      const API_DATA = this.$lodash.clone(this.form);
      this.saveApi(API_DATA);
    },

    saveApi(API_DATA) {
      console.log(API_DATA);
      axios({
        method: 'post',
        url: `http://192.168.0.170:8090/config/save`,
        data: API_DATA,
      }).then((res) => {
        if (res.data.code == 200 && res.data.msg == 'SUCCESS') {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },

    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
</style>
